<div>
    <hub-modal-header headerText="{{ 'bikeshop.rentals.booking.initiate_refund' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">
    <div>
        {{ 'bikeshop.modal.initiate.refund.stripe_terms' | translate }}
    </div>
    <div class="row margin-top-8">
        <div class="col-md-12">
            <hub-dropdown label="{{ 'bikeshop.modal.initiate_refund.select_transaction_to_refund' | translate }}"
                [labelColor]="!selectedTransaction ? '#f24646' : ''" [options]="refundOptions"
                [(ngModel)]="selectedTransaction" optionLabel="label"></hub-dropdown>
        </div>
    </div>
    <div class="row margin-top-8">
        <div class="col-md-12">
            <hub-input
                label="{{ 'bikeshop.modal.initiate_refund.enter_amount_to_refund' | translate : {maxAmount: partner.CurrencySymbol + maxRefundAmount()} }}"
                [labelColor]="!isValid() ? '#f24646' : ''" type="number" [(ngModel)]="refundAmount"
                [required]="true"></hub-input>
        </div>
    </div>

</div>

<div class="modal-footer-container">
    <div class="row margin-top-16" *ngIf="errorMessage">
        <div class="col-md-12 bold red">{{errorMessage}}</div>
    </div>
    <div class="button-container">
        <hub-button [disabled]="!isValid()" (buttonClick)="refundPayment()" [loading]="busyRefunding"
            text="{{'bikeshop.modal.initiate_refund.refund_payment'| translate}}" [style]="'secondary'"
            [size]="'xl'"></hub-button>
    </div>
</div>